class DatesStore {
  months = [
    { value: 1, key: 'январь' },
    { value: 2, key: 'февраль' },
    { value: 3, key: 'март' },
    { value: 4, key: 'апрель' },
    { value: 5, key: 'май' },
    { value: 6, key: 'июнь' },
    { value: 7, key: 'июль' },
    { value: 8, key: 'август' },
    { value: 9, key: 'сентябрь' },
    { value: 10, key: 'октябрь' },
    { value: 11, key: 'ноябрь' },
    { value: 12, key: 'декабрь' },
  ]

  secondDeclensionOfMonths = [
    { value: 1, key: 'января' },
    { value: 2, key: 'февраля' },
    { value: 3, key: 'марта' },
    { value: 4, key: 'апреля' },
    { value: 5, key: 'мая' },
    { value: 6, key: 'июня' },
    { value: 7, key: 'июля' },
    { value: 8, key: 'августа' },
    { value: 9, key: 'сентября' },
    { value: 10, key: 'октября' },
    { value: 11, key: 'ноября' },
    { value: 12, key: 'декабря' },
  ]

  getMonthName = (month, secondDeclension = false, capitalLetter = false) => {
    const monthsArray = secondDeclension
      ? this.secondDeclensionOfMonths
      : this.months
    let monthData = monthsArray.find(
      (el) => el.value === month || el.value === Number(month),
    )
    if (capitalLetter) {
      monthData.key = monthData.key[0].toUpperCase() + monthData.key.slice(1)
    }
    return monthData ? monthData.key : month
  }
}

export const datesStore = new DatesStore()

export default DatesStore
